import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useT } from "@/i18n/I18nContext";
import { Badge } from "@/components/ui/badge";
import { ClipboardList, MapPin, Package } from "lucide-react";

export default function SellerRequests() {
  const { t } = useT();
  const [requests, setRequests] = useState([]);

  useEffect(() => { api.get("/seller/requests").then((r) => setRequests(r.data)); }, []);

  return (
    <div className="container-page py-10">
      <h1 className="font-heading font-extrabold text-3xl text-secondary">{t("request.sellerTitle")}</h1>
      <p className="text-muted-foreground mt-1 mb-6">{t("request.sellerSubtitle")}</p>

      {requests.length === 0 ? (
        <div className="text-center py-20 rounded-2xl bg-card border border-dashed border-border" data-testid="seller-requests-empty">
          <ClipboardList className="h-10 w-10 mx-auto text-muted-foreground" />
          <p className="mt-4 text-muted-foreground">{t("request.noRequests")}</p>
        </div>
      ) : (
        <div className="grid gap-3">
          {requests.map((r) => (
            <div key={r.id} className="rounded-2xl bg-card border border-border p-5" data-testid={`seller-request-${r.id}`}>
              <div className="flex items-center gap-2 flex-wrap">
                <h3 className="font-heading font-semibold text-secondary">{t(`categories.${r.category}`)}</h3>
                {r.state && <Badge className="bg-secondary/10 text-secondary border-0">{t(`states.${r.state}`)}</Badge>}
                <Badge className="bg-accent/15 text-accent-foreground border-0">{t("request.open")}</Badge>
              </div>
              <div className="mt-2 flex flex-wrap gap-4 text-sm text-muted-foreground">
                <span className="flex items-center gap-1"><Package className="h-4 w-4" /> {r.quantity}</span>
                {r.region && <span className="flex items-center gap-1"><MapPin className="h-4 w-4" /> {r.region}</span>}
                {r.max_price && <span>≤ {r.max_price} FCFA</span>}
                {r.delivery_needed && <span className="text-secondary">{t("request.deliveryNeeded")}</span>}
              </div>
              {r.note && <p className="mt-2 text-sm text-foreground/70">{r.note}</p>}
              <p className="mt-2 text-xs text-muted-foreground">{r.buyer_name} · {t("seller.contactHidden")}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
